<template>
  <div class="full-width">
    <div class="table-container">
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Manufacturer</th>
            <th>Location</th>
            <th>Included Warranty</th>
            <th>Model Number</th>
            <th>Serial Number</th>
            <th>Manufacture Date</th>
            <th>Installation Date</th>
            <th>Age</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="component in components" :key="component.id" :data-cy="`component-row-${component.name}`">
            <td>{{ component.name || '--'}}</td>
            <td>{{ component.manufacturer || '--' }}</td>
            <td>{{ component.install_location || '--' }}</td>
            <td>{{ component.warranty || '--' }}</td>
            <td>{{ component.model_number || '--' }}</td>
            <td>{{ component.serial_number || '--' }}</td>
            <td>{{ manufacturedOnLabel(component.manufactured_on) || '--' }}</td>
            <td>{{ shortDate(component.installed_on) || '--' }}</td>
            <td>
              {{
                yearsAndMonthsFromNow(
                  component.installed_on || component.manufactured_on
                )
              }}
            </td>
          </tr>
          <tr v-if="!components.length">
            <td align="center" colspan="7">No components available</td>
          </tr>
        </tbody>
      </Table>
    </div>
  </div>
</template>

<script>
import Table from '@/components/Table.vue';
import { yearsAndMonthsFromNow, shortDate } from "@/mixins";
export default {
  components: {
    Table,
  },
  props: {
    components: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    shortDate,
    yearsAndMonthsFromNow,
    manufacturedOnLabel(date) {
      if (!date) return "--";
      return moment(date).format("MM/YYYY")
    }
  },
}
</script>

<style lang="scss" scoped>
.table-label {
  font-size: 1.3em;
  font-weight: bold;
}
.table-container {
  overflow-x: auto;
}
</style>